module.exports = __webpack_public_path__ + "img/4.2aba018e.png";